import { type FunctionalComponent, h } from '@stencil/core';
import { ConversationalSearchSkeleton } from '../../../conversational-search-partials/skeleton/skeleton';

export const ConversationalSearchDynamicBannerLoadingResult: FunctionalComponent<{}> = (props) => {
    return (<span>
      <ConversationalSearchSkeleton itemsAmount={2} />
      <br></br>
      <ConversationalSearchSkeleton itemsAmount={3} />
    </span>
    );
};
